/**
 * @description: 企业测评企业端路由配置
 *
 * @author: kangzijuan
 *
 * @createTime: 2021-11-26 10:13:13
 */
const ENTERPRISE = [{
  path: '/enterpriseInfo',
  name: 'enterpriseInfo',
  // 按需加载路由
  component: () => import('@/views/currentEvaluation/enterpriseInfo'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: ' 企业信息',
      path: '/enterpriseInfo'
    }]
  }
}, {
  path: '/evaluationResults',
  name: 'evaluationResults',
  // 按需加载路由
  component: () => import('@/views/currentEvaluation/evaluationResults'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '测评报告',
      path: '/evaluationResults'
    }]
  }
}, {
  path: '/doubtfulPointManagement',
  name: 'doubtfulPointManagement',
  // 按需加载路由
  component: () => import('@/views/doubtfulPointManagement/doubtfulPointManagement'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '疑点管理',
      path: '/doubtfulPointManagement'
    }]
  }
}, {
  path: '/infoAcquisition/selfTest',
  name: 'selfTest',
  // 按需加载路由
  component: () => import('@/views/currentEvaluation/currentEvaluation'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '即时测评',
      path: '/infoAcquisition/selfTest'
    }]
  }
}, {
  path: '/infoAcquisition/currentEvaluation',
  name: 'currentEvaluation',
  // 按需加载路由
  component: () => import('@/views/currentEvaluation/currentEvaluation'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '本期测评',
      path: '/infoAcquisition/currentEvaluation'
    }]
  }
}, {
  path: '/historicalEvaluation',
  name: 'historicalEvaluation',
  // 按需加载路由
  component: () => import('@/views/historicalEvaluation/historicalEvaluation'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '历史测评',
      path: '/historicalEvaluation'
    }]
  }
}, {
  path: '/dissentManagement',
  name: 'dissentManagement',
  // 按需加载路由
  component: () => import('@/views/dissentManagement/dissentManagement'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '异议管理',
      path: '/dissentManagement'
    }]
  }
}, {
  path: '/myNotification',
  name: 'myNotification',
  // 按需加载路由
  component: () => import('@/views/myNotification/myNotification'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '我的通知',
      path: '/myNotification'
    }]
  }
}, {
  path: '/userInformation',
  name: 'userInformation',
  // 按需加载路由
  component: () => import('@/views/person/personCenter'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '用户信息管理',
      path: '/userInformation'
    }]
  }
}, {
  path: '/instructions',
  name: 'instructions',
  // 按需加载路由
  component: () => import('@/views/fillingInstructions/instrc'),
  // meta，具体用法请参照vue-router文档
  meta: {
    // 是否需要登录
    isLogin: true,
    // 是否需要鉴权
    isAuth: false,
    btnAuthList: [],
    data: [{
      title: '填报说明',
      path: '/instructions'
    }]
  }
}]
export default ENTERPRISE
